// extracted by mini-css-extract-plugin
export default {"sidebar":"EventPageSidebar_sidebar__ODnS7"};